var _rect, _title, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOffRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ionicons-v5-g") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("line", {
    x1: 432.5813903808594,
    y1: 400,
    x2: 96.5813980102539,
    y2: 64,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 32
    },
    id: "svg_1",
    className: "",
    stroke: "#d92e2e",
    strokeOpacity: 1,
    fillOpacity: 1
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400,240V208.45c0-8.61-6.62-16-15.23-16.43A16,16,0,0,0,368,208v32a111.68,111.68,0,0,1-2.68,24.38,2,2,0,0,0,.53,1.84l22.59,22.59a2,2,0,0,0,3.29-.72A143.27,143.27,0,0,0,400,240Z",
    id: "svg_2",
    className: "",
    fillOpacity: 1,
    fill: "#d92e2e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5813953280449,352 A112.36,112.36 0 0 1 144.5813953280449,240 V208.45 c0,-8.61 -6.62,-16 -15.23,-16.43 A16,16 0 0 0 112.58139532804489,208 v32 c0,74 56.1,135.12 128,143.11 V432 H193.03139532804488 c-8.61,0 -16,6.62 -16.43,15.23 A16,16 0 0 0 192.5813953280449,464 H320.1313953280449 c8.61,0 16,-6.62 16.43,-15.23 A16,16 0 0 0 320.5813953280449,432 H272.5813953280449 V383.11 a143.08,143.08 0 0 0 52,-16.22 a4,4 0 0 0 0.91,-6.35 l-18.4,-18.39 a3,3 0 0 0 -3.41,-0.5800000000000001 A111,111 0 0 1 256.5813953280449,352 z",
    id: "svg_3",
    className: "",
    stroke: "#ffffff",
    strokeOpacity: 1,
    fill: "#d92e2e",
    fillOpacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5586046719551,47.41860467195511 a79.66,79.66 0 0 0 -68.47,36.57 a4,4 0 0 0 0.54,5 L332.0086046719551,232.4186046719551 a2,2 0 0 0 3.41,-1.42 V128.3286046719551 C335.4186046719551,84.41860467195511 300.4186046719551,48.01860467195511 256.5586046719551,47.41860467195511 z",
    id: "svg_4",
    className: "",
    fillOpacity: 1,
    fill: "#d92e2e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.9913953280449,214.41520470380783 a2,2 0 0 0 -3.41,1.42 V238.41520470380783 a80.89,80.89 0 0 0 23.45,56.9 a78.55,78.55 0 0 0 77.8,21.19 a2,2 0 0 0 0.8600000000000002,-3.35 z",
    id: "svg_5",
    className: "",
    fillOpacity: 1,
    fill: "#d92e2e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOffRed);
export default __webpack_public_path__ + "static/media/mic-off-red.0d169e5d6e48a9e89147a76c90afe46b.svg";
export { ForwardRef as ReactComponent };